import ModalConfig from "./ModalConfig";

export default ModalConfig;
